import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import pb from '../../services/pocketbase';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './AuthPage.css';

function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const navigate = useNavigate();
  const { login, register, user } = useAuth();

  useEffect(() => {
    // Si l'utilisateur est déjà connecté, le rediriger
    if (user) {
      navigate(user.role === 'admin' ? '/admin' : '/mon-compte');
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    const { email, password } = e.target.elements;
    try {
      await login(email.value, password.value);
      // La redirection est gérée par l'effet ci-dessus
    } catch (error) {
      alert('Erreur de connexion. Vérifiez vos identifiants.');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const { name, email, password, passwordConfirm } = e.target.elements;
    if (password.value !== passwordConfirm.value) {
      return alert('Les mots de passe ne correspondent pas.');
    }
    try {
      await register(email.value, password.value, passwordConfirm.value, name.value);
      alert('Inscription réussie ! Vous êtes maintenant connecté.');
      // La redirection est gérée par l'effet ci-dessus
    } catch (error) {
      alert("Erreur lors de l'inscription.");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setResetMessage('');
    
    if (!resetEmail.trim()) {
      setResetMessage('Veuillez saisir votre adresse email.');
      return;
    }

    try {
      await pb.collection('users').requestPasswordReset(resetEmail);
      setResetMessage('Un email de réinitialisation a été envoyé à votre adresse.');
      setResetEmail('');
    } catch (error) {
      console.error('Erreur lors de la demande de réinitialisation:', error);
      setResetMessage('Erreur lors de l\'envoi de l\'email. Vérifiez votre adresse.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {showForgotPassword ? (
          <>
            <h2>Mot de passe oublié</h2>
            <form onSubmit={handleForgotPassword}>
              <div className="input-group">
                <label htmlFor="resetEmail">Adresse email</label>
                <input 
                  type="email" 
                  id="resetEmail" 
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  placeholder="Votre adresse email"
                  required 
                />
              </div>
              <button type="submit" className="auth-button">Envoyer l'email de réinitialisation</button>
            </form>
            {resetMessage && (
              <p className={`reset-message ${resetMessage.includes('envoyé') ? 'success' : 'error'}`}>
                {resetMessage}
              </p>
            )}
            <button 
              onClick={() => {
                setShowForgotPassword(false);
                setResetMessage('');
                setResetEmail('');
              }} 
              className="toggle-button"
            >
              Retour à la connexion
            </button>
          </>
        ) : (
          <>
            <h2>{isLogin ? 'Connexion' : 'Inscription'}</h2>
            <form onSubmit={isLogin ? handleLogin : handleRegister}>
          {!isLogin && (
            <div className="input-group">
              <label htmlFor="name">Nom</label>
              <input type="text" id="name" name="name" required />
            </div>
          )}
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div className="input-group">
            <label htmlFor="password">Mot de passe</label>
            <div className="password-input-container">
              <input 
                type={showPassword ? "text" : "password"} 
                id="password" 
                name="password" 
                required 
              />
              <button 
                type="button" 
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          {!isLogin && (
            <div className="input-group">
              <label htmlFor="passwordConfirm">Confirmer le mot de passe</label>
              <div className="password-input-container">
                <input 
                  type={showPasswordConfirm ? "text" : "password"} 
                  id="passwordConfirm" 
                  name="passwordConfirm" 
                  required 
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                  aria-label={showPasswordConfirm ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  {showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
          )}
              <button type="submit" className="auth-button">{isLogin ? 'Se connecter' : "S'inscrire"}</button>
            </form>
            
            {isLogin && (
              <button 
                onClick={() => setShowForgotPassword(true)} 
                className="forgot-password-link"
              >
                Mot de passe oublié ?
              </button>
            )}
            
            <button onClick={() => setIsLogin(!isLogin)} className="toggle-button">
              {isLogin ? 'Pas encore de compte ? Inscrivez-vous' : 'Déjà un compte ? Connectez-vous'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthPage;
